import { useMutation, useQueryClient } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { NotificationApiService } from 'features/notification/api/notification-api.service';

import { NotificationQueryKeys } from './query.keys';

const { createNotificationSend } = NotificationApiService();

export const useCreateNotificationSend = () => {
  const { message } = App.useApp();
  const queryClient = useQueryClient();

  return useMutation(
    (payload: any) => {
      return createNotificationSend(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: (data: any) => {
        queryClient.invalidateQueries({
          queryKey: NotificationQueryKeys.all,
        });
        message.success(data?.ResponseMessage);
      },
    },
  );
};
